import * as React from "react";
import type { SVGProps } from "react";
const SvgEmptyPhasesTimeline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={82}
    height={99}
    fill="none"
    viewBox="0 0 82 99" {...props}
  >
    <path
      fill="url(#empty-phases-timeline_svg__a)"
      d="m45.989 23.012-30.78 27.775c-1.612 1.465-1.209 4.067.733 4.983l31.44 14.767a3.75 3.75 0 0 0 4.177-.66l26.895-24.953c1.136-1.063.843-2.932-.586-3.554l-22.242-9.82-.073-2.2c-.037-1.245-.806-2.344-1.942-2.857z"
      opacity={0.7}
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeMiterlimit={10}
      strokeWidth={0.733}
      d="m45.989 16.453-30.78 27.812c-1.612 1.465-1.209 4.067.733 4.983l31.44 14.767a3.75 3.75 0 0 0 4.177-.66l26.895-24.953c1.136-1.063.843-2.931-.586-3.555l-22.242-9.82-.073-2.198c-.037-1.246-.806-2.345-1.942-2.858l-7.622-3.481z"
    />
    <path
      fill="#00217B"
      d="M70.392 82.039a2.931 2.931 0 1 0 0-5.863 2.931 2.931 0 0 0 0 5.862"
    />
    <path
      fill="#00D9CA"
      d="m37.342 7.841-5.423.44c-1.246 0-1.979.22-2.235 1.32l-.77 6.705-.66-5.643c-.11-.953-.11-2.015-1.465-2.309l-6.083-.403 4.947-.513c2.235-.33 2.602-1.319 2.748-2.235s0-.183 0-.293L28.878 0l.513 4.727c.11.953.513 2.125 1.392 2.345l6.632.806z"
      opacity={0.5}
    />
    <path
      fill="#FFCE00"
      d="m3.776 19.789-3.151 3.59c-.623.734-.806 1.76-.44 2.64l1.063 2.49a3 3 0 0 0 1.869 1.723l2.491.806c.916.293 1.906 0 2.529-.696l3.517-3.994c.44-.513.587-1.21.367-1.869l-1.063-3.188a2.16 2.16 0 0 0-1.539-1.429l-3.408-.88c-.842-.22-1.685.074-2.271.697z"
    />
    <path
      fill="#B0D2FF"
      d="M45.548 29.681 31.144 42.658a.874.874 0 0 0 .216 1.442l17.432 8.113a.87.87 0 0 0 .942-.132l14.404-12.513a.874.874 0 0 0-.188-1.444L46.52 29.547a.87.87 0 0 0-.971.134"
    />
    <path
      stroke="#fff"
      strokeWidth={1.748}
      d="m34.533 47.209 18.14-15.736M39.478 32.35l21.484 10.732M34.532 37.936l21.483 10.732M42.837 50.705l18.14-15.736"
    />
    <path
      stroke="#00217B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.696}
      d="M36.243 25.208S12.865 13.812 4.51 24.622c-16.525 21.252 56.32 24.55 71.893 38.95 15.572 14.4-12.056 17.808-28.765 19.75-25.76 3.005-24.55 14.987-24.55 14.987"
      opacity={0.3}
    />
    <path
      fill="#00217B"
      d="M58.426 28.219a.367.367 0 0 0 .731-.053zm2.77-3.305v-.366h-.03zm-2.404 3.278.365-.026c-.032-.461.04-1.166.348-1.76.299-.577.816-1.051 1.721-1.127l-.03-.365-.03-.365c-1.193.1-1.914.754-2.311 1.519-.387.745-.468 1.592-.429 2.15zm2.404-3.278v.366c.559 0 1.36.181 1.95.697.566.494.993 1.343.749 2.81l.361.061.361.06c.28-1.68-.204-2.797-.989-3.483-.76-.665-1.752-.877-2.432-.877z"
    />
    <path
      fill="#00217B"
      d="M62.15 29.531a.367.367 0 0 0 .732-.052zm2.77-3.304v-.367l-.03.001zm-2.404 3.278.366-.026c-.033-.462.039-1.166.348-1.761.298-.576.816-1.05 1.721-1.126l-.03-.365-.03-.366c-1.194.1-1.915.754-2.312 1.52-.387.744-.468 1.592-.428 2.15zm2.405-3.278v.366c.558 0 1.36.18 1.95.696.566.495.993 1.344.748 2.811l.361.06.362.06c.28-1.679-.204-2.797-.99-3.483-.76-.664-1.752-.877-2.431-.877z"
    />
    <path
      fill="#00217B"
      d="M65.875 31.277a.367.367 0 0 0 .731-.052zm2.77-3.304v-.367q-.015 0-.03.002zm-2.404 3.278.365-.026c-.033-.462.04-1.166.348-1.761.299-.576.816-1.05 1.722-1.126l-.03-.365-.031-.365c-1.193.099-1.914.753-2.311 1.518-.387.745-.469 1.593-.429 2.151zm2.404-3.278v.366c.559 0 1.36.18 1.95.697.566.494.993 1.343.749 2.81l.36.06.362.061c.28-1.68-.204-2.798-.989-3.483-.76-.665-1.752-.878-2.432-.878z"
    />
    <defs>
      <linearGradient
        id="empty-phases-timeline_svg__a"
        x1={37.561}
        x2={61.525}
        y1={4.947}
        y2={118.721}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#228FE6" />
        <stop offset={0.2} stopColor="#1AA0E0" />
        <stop offset={0.3} stopColor="#0DBBD6" />
        <stop offset={0.4} stopColor="#00DACB" />
        <stop offset={0.8} stopColor="#00DACB" stopOpacity={0.4} />
        <stop offset={1} stopColor="#00DACB" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgEmptyPhasesTimeline;
